
  export default {
  name:'Transcript',
    props: {
      tooltip: {
        default: '',
        type: String,
      },
      text: {
        default: '',
        type: String,
      },
      flow: {
        default: 'up',
        type: String,
      },
    },
    data(){
        return{
            showMore: false,
            tHeight: 500,
            convertedTranscript: '',
            showButton: true
        }
    },
    mounted() {
      this.convertedTranscript = this.convertTranscriptToHTML();
    },
    methods: {
      toggleMore(){
        this.tHeight = this.tHeight+100
        this.showMore = true
      },
      toggleLess(){
        this.tHeight = 500
        this.showMore = false
      },
      convertTranscriptToHTML() {
        const slot = this.$refs.mySlot.innerHTML;
        console.log('SLOT',slot)
        if (slot !== '<p></p>'){
          this.showButton = true
          return slot.replace(/([A-Za-z0-9_-\s]+)(\s\(\d{2}:\d{2}\))/g, '<strong class="speaker">$1 $2</strong>');
        }
        this.showButton = false
        return '<p class="text-center pb-0 mb-0">Transcript coming soon!</p>'
      }
    }
  }
  